import { EntityList } from '../../components/entity-list';
import { ClassroomForm } from '../../forms/simple-forms';
import { useT } from '../../i18n';
import { useTenant } from '../../tenant/tenant-provider';

/**
 * The classrooms of the selected sede.
 */
export const ClassroomsScreen = () => {
  const t = useT();
  const { session, sede } = useTenant();
  return (
    <EntityList
      entity="classrooms"
      query={{ sedeId: sede.id }}
      title={t('classrooms.title')}
      caption={t('classrooms.caption')}
      createLabel={t('classrooms.new')}
      editTitle={t('classrooms.edit')}
      emptyTitle={t('classrooms.empty.title')}
      emptyBody={t('classrooms.empty.body')}
      toolbar={<p className="text-sm text-gray-500">{t('groups.sedeNote', { sede: sede.name })}</p>}
      columns={[
        {
          key: 'name',
          header: t('classrooms.column.name'),
          cell: (row) => <span className="font-medium text-gray-900">{row.name}</span>,
          sortable: true,
          sortValue: (row) => row.name,
        },
        {
          key: 'capacity',
          header: t('classrooms.column.capacity'),
          cell: (row) => row.capacity ?? t('common.none'),
          align: 'right',
        },
      ]}
      renderForm={({ current, onDone }) => (
        <ClassroomForm sedes={session.sedes} sedeId={sede.id} current={current} onDone={onDone} />
      )}
    />
  );
};
